import { exportsKey } from '../keys'
import { useQueryClient } from '@tanstack/react-query'
import { Logger, type ExportData, type ExportId } from '@terros/common'

const logger = new Logger('useExportCache')

type ExportCache = {
  clearList: () => void
  addItem: (item: ExportData) => void
  replaceItem: (item: ExportData) => void
  removeItem: (exportId: ExportId) => void
}

export function useExportCache(): ExportCache {
  const queryClient = useQueryClient()
  return {
    clearList: () => {
      logger.verbose('invalidateQueries exports and downloads')
      queryClient.invalidateQueries({ queryKey: exportsKey({}) })
      queryClient.invalidateQueries({ queryKey: ['export-download'] })
    },
    addItem: (item: ExportData) => {
      logger.verbose('addItem export', item)
      queryClient.setQueryData<ExportData[]>(exportsKey({}), (old) => [...(old || []), item])
    },
    replaceItem: (item: ExportData) => {
      logger.verbose('replaceItem export', item)
      queryClient.setQueryData<ExportData[]>(exportsKey({}), (old) => {
        if (!old) {
          return [item]
        }
        return old.map((t) => (t.exportId === item.exportId ? item : t))
      })
    },
    removeItem: (exportId: ExportId) => {
      logger.verbose('removeItem exportId', exportId)
      queryClient.setQueryData<ExportData[]>(exportsKey({}), (old) => old?.filter((t) => t.exportId !== exportId))
    },
  }
}
